import { Input } from "antd";
import { forwardRef } from "react";
import "./input_comp.scss";

const InputPhoneNumber = forwardRef(
  (
    {
      placeholder,
      className,
      type = "text",
      id,
      label,
      layoutClass,
      showCount = false,
      value,
      onChange,
      name,
      maxLength,
      labelClass,
      disabled = false,
      autoFocus = false,
    },
    ref
  ) => {
    // Here 'ref' is received from the parent component
    const handleInputChange = (e) => {
      let inputValue = e.target.value;

      // If the input type is 'number' and maxLength is defined, ensure it doesn't exceed maxLength
      if (type === "number" && maxLength) {
        inputValue = inputValue.slice(0, maxLength); // Slice the input to the maxLength
      }

      if (onChange) {
        onChange({
          ...e,
          target: {
            ...e.target,
            value: inputValue,
          },
        });
      }
    };

    return (
      <div className={`input-comp ${layoutClass || ""}`}>
        {label && (
          <label className={`${labelClass || "input-label"}`} htmlFor={id}>
            {label}
          </label>
        )}
        <Input
          showCount={showCount}
          disabled={disabled}
          maxLength={maxLength}
          autoFocus={autoFocus}
          type={type}
          name={name}
          value={value}
          id={id}
          placeholder={placeholder}
          onChange={handleInputChange}
          className={className}
          ref={ref} // Forwarding the ref to Ant Design Input
        />
      </div>
    );
  }
);

export default InputPhoneNumber;
